export type TrailerSource = { kind: "video" | "embed"; url: string }

export function trailerSource(src: string): TrailerSource | null {
    let url: URL
    try {
        url = new URL(src)
    } catch {
        return null
    }
    if (!['https:', 'http:'].includes(url.protocol)) return null
    if (/\.(mp4|webm|mov)$/i.test(url.pathname)) return { kind: "video", url: src }

    const host = url.hostname.toLowerCase()
    if (host === "rutube.ru" || host === "www.rutube.ru") {
        const id = url.pathname.match(/^\/(?:video|play\/embed|embed)\/([a-f0-9]{32})\/?$/i)?.[1]
        if (!id) return null
        const embed = new URL(`https://rutube.ru/play/embed/${id}/`)
        // Preserve Rutube's token for existing private embed links.
        const token = url.searchParams.get("p")
        if (token) embed.searchParams.set("p", token)
        embed.searchParams.set("autoplay", "true")
        return { kind: "embed", url: embed.toString() }
    }
    if (["youtube.com", "www.youtube.com", "m.youtube.com", "youtu.be", "www.youtube-nocookie.com"].includes(host)) {
        const id = host === "youtu.be"
            ? url.pathname.slice(1)
            : url.searchParams.get("v") || url.pathname.match(/^\/(?:embed|shorts)\/([^/]+)/)?.[1]
        if (!id || !/^[\w-]{11}$/.test(id)) return null
        return { kind: "embed", url: `https://www.youtube.com/embed/${id}?autoplay=1` }
    }
    return null
}
